export default {
      id: "ic-han-hearing-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-han-hearing-usage",
      toString: function () {
        return this.url;
      }
    }